import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createOrganizationalUnit(
    request: Boundaries["createOrganizationalUnit"]["request"],
  ): void;
}

function useCreateOrganizationalUnit(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isCreateOrganizationalUnitRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isCreateOrganizationalUnitRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isCreateOrganizationalUnitRequestFailure,
    ),
    createOrganizationalUnit: core.createOrganizationalUnit,
  };
}

export { useCreateOrganizationalUnit };
